/** 站内信分类展示配置（新增 category/msgType 时在此扩展） */
export const INBOX_CATEGORY_META = {
  workflow: { label: '审批', color: 'blue' },
  business: { label: '业务', color: 'green' },
  system: { label: '系统', color: 'default' },
  admin: { label: '公告', color: 'purple' }
};

export const INBOX_MSG_TYPE_META = {
  approve: { label: '待审批', variant: 'pending' },
  cc: { label: '抄送', variant: 'info' },
  execute: { label: '待执行', variant: 'pending' },
  finished: { label: '已通过', variant: 'success' },
  rejected: { label: '已驳回', variant: 'rejected' },
  return: { label: '已退回', variant: 'warning' },
  plan_sub_assigned: { label: '子任务指派', variant: 'pending' },
  plan_dept_matter: { label: '部门重点工作', variant: 'info' },
  plan_sub_terminal: { label: '子任务进展', variant: 'success' },
  plan_personal_due: { label: '待办临期', variant: 'pending' },
  plan_due_extended: { label: '计划延期', variant: 'info' },
  plan_report_draft: { label: '周报待确认', variant: 'pending' },
  plan_report_submitted: { label: '周报已提交', variant: 'info' },
  plan_progress_missing: { label: '进展待填写', variant: 'warning' },
  archive_confirm_pending: { label: '待档案确认', variant: 'pending' },
  announcement: { label: '通知通告', variant: 'info' }
};

export function getCategoryMeta(category) {
  return INBOX_CATEGORY_META[category] || { label: category || '消息', color: 'default' };
}

export function getMsgTypeMeta(msgType) {
  return INBOX_MSG_TYPE_META[msgType] || { label: msgType || '通知', variant: 'info' };
}

export const INBOX_CATEGORY_TABS = [
  { key: '', label: '全部' },
  { key: 'workflow', label: '审批' },
  { key: 'business', label: '业务' },
  { key: 'system', label: '系统' },
  { key: 'admin', label: '公告' }
];
